export const apiRoot = process.env.VUE_APP_API_ROOT || 'https://api.cicimm.net/api/v1';
export const loginRoot = process.env.VUE_APP_LOGIN_ROOT || 'https://api.cicimm.net/api';
export const imgRoot = process.env.VUE_APP_IMG_ROOT || 'https://api.cicimm.net/';
// export const apiRoot = 'https://5d97-2403-6200-88a0-1b7d-7df1-c126-7e81-754c.ngrok-free.app/api';
// export const loginRoot = 'https://5d97-2403-6200-88a0-1b7d-7df1-c126-7e81-754c.ngrok-free.app/api';
// export const imgRoot = 'https://5d97-2403-6200-88a0-1b7d-7df1-c126-7e81-754c.ngrok-free.app/api';
export const version = '1.24';
